import React from 'react';
import { X } from 'lucide-react';

export default function AdminModal({ title, onClose, children, footer, wide }) {
  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
      <div
        className={`bg-[#111827] border border-[#1E2D45] rounded-2xl w-full max-h-[90vh] overflow-hidden flex flex-col
          ${wide ? 'max-w-2xl' : 'max-w-lg'}`}
      >
        <div className="flex items-center justify-between p-5 border-b border-[#1E2D45] flex-shrink-0">
          <h3 className="text-white font-bold">{title}</h3>
          <button
            type="button"
            onClick={onClose}
            className="text-[#546E7A] hover:text-white transition-colors"
          >
            <X size={20} />
          </button>
        </div>
        <div className="p-5 overflow-y-auto flex-1">{children}</div>
        {footer && (
          <div className="flex gap-3 p-5 border-t border-[#1E2D45] flex-shrink-0">{footer}</div>
        )}
      </div>
    </div>
  );
}

export function ModalFooter({ onCancel, onSave, saving, saveLabel = 'Save', saveClass = 'bg-[#2D5BE3] hover:bg-[#1A3C8F]' }) {
  return (
    <>
      <button
        type="button"
        onClick={onCancel}
        className="flex-1 py-2.5 bg-[#1A2235] border border-[#1E2D45] text-[#B0BEC5] rounded-xl text-sm hover:text-white transition-colors"
      >
        Cancel
      </button>
      <button
        type="button"
        onClick={onSave}
        disabled={saving}
        className={`flex-1 py-2.5 text-white rounded-xl text-sm font-semibold transition-colors disabled:opacity-50 ${saveClass}`}
      >
        {saving ? 'Saving...' : saveLabel}
      </button>
    </>
  );
}

export function FormInput({ label, value, onChange, type = 'text', required, placeholder, className = '' }) {
  return (
    <div className={className}>
      <label className="block text-xs text-[#B0BEC5] mb-1">
        {label}{required && ' *'}
      </label>
      <input
        type={type}
        value={value ?? ''}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full px-3 py-2 bg-[#1A2235] border border-[#1E2D45] rounded-xl text-white text-sm
          placeholder-[#546E7A] focus:outline-none focus:border-[#2D5BE3]"
      />
    </div>
  );
}

export function FormSelect({ label, value, onChange, options, className = '' }) {
  return (
    <div className={className}>
      <label className="block text-xs text-[#B0BEC5] mb-1">{label}</label>
      <select
        value={value}
        onChange={e => onChange(e.target.value)}
        className="w-full px-3 py-2 bg-[#1A2235] border border-[#1E2D45] rounded-xl text-white text-sm
          focus:outline-none focus:border-[#2D5BE3]"
      >
        {options.map(o => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
    </div>
  );
}

export function Toggle({ label, checked, onChange, color = '#2D5BE3' }) {
  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={() => onChange(!checked)}
        className="w-10 h-6 rounded-full transition-colors"
        style={{ background: checked ? color : '#1E2D45' }}
      >
        <div
          className={`w-4 h-4 bg-white rounded-full mx-1 transition-transform
            ${checked ? 'translate-x-4' : 'translate-x-0'}`}
        />
      </button>
      <span className="text-sm text-[#B0BEC5]">{label}</span>
    </div>
  );
}
